// src/hooks/useGoogleMaps.js
import { useState, useEffect } from 'react';

let loaderPromise = null;

/**
 * Modern "Dynamic Library Loading" pattern for Google Maps.
 */
export const useGoogleMaps = (apiKey) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    if (window.google?.maps?.importLibrary) {
      setIsLoaded(true);
      return;
    }

    if (!loaderPromise) {
      loaderPromise = new Promise((resolve, reject) => {
        /* eslint-disable no-unused-expressions, no-sequences, no-param-reassign */
        // Official Google Maps Dynamic Library Loader
        (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.googleapis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?(console.warn(p+" only loads once. Ignoring:",g),resolve()):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
          key: apiKey,
          v: "weekly"
        });
        /* eslint-enable no-unused-expressions, no-sequences, no-param-reassign */
        
        // Wait for core and places libraries to be ready
        Promise.all([
          window.google.maps.importLibrary("core"),
          window.google.maps.importLibrary("places")
        ])
          .then(() => {
            console.log('✅ [GoogleMapsHook] Core & Places Libraries loaded');
            resolve();
          })
          .catch(reject);
      });
    }

    loaderPromise
      .then(() => setIsLoaded(true))
      .catch((err) => {
        console.error('❌ [GoogleMapsHook] Load failed:', err);
        setLoadError(err);
      });
  }, [apiKey]);

  return { isLoaded, loadError };
};
